import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const InvoicesIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.3337 22.6668V25.3335C21.3337 26.0407 21.0527 26.719 20.5526 27.2191C20.0525 27.7192 19.3742 28.0002 18.667 28.0002H9.33366C8.62642 28.0002 7.94814 27.7192 7.44804 27.2191C6.94794 26.719 6.66699 26.0407 6.66699 25.3335V12.0002C6.66699 11.2929 6.94794 10.6146 7.44804 10.1145C7.94814 9.61445 8.62642 9.3335 9.33366 9.3335H12.0003"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14 4H19L20.5 11H26.5V20.5L25 22.5H14.5L12.5 21L12 6L14 4Z"
          fill="#66D8F2"
        />
        <path
          d="M24 22.6667H14.6667C13.9594 22.6667 13.2811 22.3857 12.781 21.8856C12.281 21.3855 12 20.7072 12 20V6.66667C12 5.95942 12.281 5.28115 12.781 4.78105C13.2811 4.28095 13.9594 4 14.6667 4H20L26.6667 10.6667V20C26.6667 20.7072 26.3857 21.3855 25.8856 21.8856C25.3855 22.3857 24.7072 22.6667 24 22.6667Z"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20 4V9.33333C20 9.68696 20.1405 10.0261 20.3905 10.2761C20.6406 10.5262 20.9797 10.6667 21.3333 10.6667H26.6667"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 13H18.5C18.1022 13 17.7206 13.158 17.4393 13.4393C17.158 13.7206 17 14.1022 17 14.5C17 14.8978 17.158 15.2794 17.4393 15.5607C17.7206 15.842 18.1022 16 18.5 16H19.5C19.8978 16 20.2794 16.158 20.5607 16.4393C20.842 16.7206 21 17.1022 21 17.5C21 17.8978 20.842 18.2794 20.5607 18.5607C20.2794 18.842 19.8978 19 19.5 19H17M19 19V20M19 12V13"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 13H18.5C18.1022 13 17.7206 13.158 17.4393 13.4393C17.158 13.7206 17 14.1022 17 14.5C17 14.8978 17.158 15.2794 17.4393 15.5607C17.7206 15.842 18.1022 16 18.5 16H19.5C19.8978 16 20.2794 16.158 20.5607 16.4393C20.842 16.7206 21 17.1022 21 17.5C21 17.8978 20.842 18.2794 20.5607 18.5607C20.2794 18.842 19.8978 19 19.5 19H17M19 19V20M19 12V13"
          stroke="#1A1721"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Center>
  );
};
